import * as React from 'react';

import { observer } from 'mobx-react';
import { PricingCards } from 'components/account/pricing-cards';
import { styled } from '@naan/stitches.config';
import { VSpacer } from '@naan/primitives/spacer';
import { PlainCouponLink } from '../../coupons/coupon-buttons';
// import { Link } from 'react-router-dom';

import __ from 'core/lib/localization';
import { ExternalLink } from '@naan/primitives/text/external-link';

const Wrapper = styled('div', {
  $$textColor: '$colors$white',
  $$linkColor: 'inherit',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  maxWidth: 632,
  '& .copy': {
    textAlign: 'center',
    color: '$$textColor',
    '& a': {
      color: '$$linkColor',
    },
  },
  variants: {
    presentation: {
      light: {
        $$textColor: '$colors$textPrimary',
        $$linkColor: '$colors$teal-500',
      },
    },
  },
});

type WrapperFlowProps = React.ComponentProps<typeof Wrapper>;

export const AuthenticatedFlow = observer(({ ...props }: WrapperFlowProps) => {
  return (
    <Wrapper {...props}>
      <PricingCards />
      <VSpacer size={12} />
      <div className="copy">
        <PlainCouponLink />
      </div>

      <VSpacer size={6} />
      <div className="copy">
        <strong>
          {__('Teaching with Jiveworld?', 'auth.teachingWithJiveworld')}{' '}
        </strong>
        <br />
        <ExternalLink href={'https://www.lupa.app/schools/plans'}>
          {__(
            'Learn about our classroom licenses',
            'auth.learnAboutClassroomLicenses'
          )}
        </ExternalLink>
      </div>
    </Wrapper>
  );
});
